module.exports = __webpack_public_path__ + "img/logo.a4bd9997.svg";